// あり・なし
export const Exists = Object.freeze([
  {
    key: 0,
    value: 'なし',
  },
  {
    key: 1,
    value: 'あり',
  },
]);

// 問い合わせ方法
export const ToiawaseCodes = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: '電話',
  },
  {
    key: 2,
    value: 'HPフォーム',
  },
  {
    key: 3,
    value: 'メール',
  },
  {
    key: 4,
    value: '飛び込み来店',
  },
  {
    key: 5,
    value: '植田',
  },
  {
    key: 6,
    value: 'LINE',
  },
  {
    key: 7,
    value: 'インスタ',
  },
  {
    key: 99,
    value: 'その他',
  },
]);

// 作業区分
export const WorkKbns = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: '外構＆ガーデン',
  },
  {
    key: 2,
    value: '住宅リフォーム',
  },
]);

// 希望プラン
export const WishPlans = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: '新築外構(建築前)',
  },
  {
    key: 2,
    value: '新築外構(建築中)',
  },
  {
    key: 3,
    value: '新築外構(入居前)',
  },
  {
    key: 4,
    value: '新築外構(入居済)',
  },
  {
    key: 5,
    value: '外構リフォーム',
  },
  {
    key: 6,
    value: 'ガーデンリフォーム',
  },
  {
    key: 7,
    value: '手つかずスペース',
  },
  {
    key: 8,
    value: '追加工事',
  },
  {
    key: 9,
    value: '住宅（水まわり）',
  },
  {
    key: 10,
    value: '住宅（内装）',
  },
  {
    key: 11,
    value: '住宅（外壁＆屋根塗装）',
  },
  {
    key: 12,
    value: '住宅（その他）',
  },
  {
    key: 14,
    value: 'メンテ',
  },
  {
    key: 15,
    value: '補修',
  },
  {
    key: 16,
    value: '店舗',
  },
  {
    key: 13,
    value: 'その他',
  },
]);

// 予算
export const Budgets = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: '50 ～ 100万',
  },
  {
    key: 2,
    value: '100 ～ 150万',
  },
  {
    key: 3,
    value: '150 ～ 200万',
  },
  {
    key: 4,
    value: '200 ～ 250万',
  },
  {
    key: 5,
    value: '250 ～ 300万',
  },
  {
    key: 6,
    value: '300 ～ 350万',
  },
  {
    key: 7,
    value: '350 ～ 500万',
  },
  {
    key: 8,
    value: '500万以上',
  },
  {
    key: 9,
    value: '未定',
  },
]);

// ガーデンリフォームローン会社
export const LoanCompanies = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: 'オリコ',
  },
  {
    key: 2,
    value: 'LIXIL',
  },
  {
    key: 3,
    value: 'タカショー',
  },
  {
    key: 99,
    value: 'その他',
  },
]);

// 期間
export const Periods = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 1,
    value: '上旬',
  },
  {
    key: 2,
    value: '中旬',
  },
  {
    key: 3,
    value: '下旬',
  },
]);

// お客様ランク
export const ClientRanks = Object.freeze([
  {
    key: '',
    value: ' ',
  },
  {
    key: 'S',
    value: 'Ｓ',
  },
  {
    key: 'A',
    value: 'Ａ',
  },
  {
    key: 'B',
    value: 'Ｂ',
  },
  {
    key: 'C',
    value: 'Ｃ',
  },
]);

// LINE登録
export const Lines = Object.freeze([
  {
    key: 0,
    value: 'なし',
  },
  {
    key: 1,
    value: 'あり',
  },
]);

// 打合せ状況
export const MeetingStatus = Object.freeze([
  {
    key: 0,
    value: ' ',
  },
  {
    key: 2,
    value: '現在他のお店に行っている',
  },
  {
    key: 1,
    value: '今後他のお店にも行く予定',
  },
  {
    key: 7,
    value: '住宅会社のプランと検討',
  },
  {
    key: 4,
    value: '現在他のお店に行く予定はない',
  },
  {
    key: 6,
    value: 'Assemble Gardenに決めている',
  },
  {
    key: 5,
    value: 'Assemble Gardenがダメだった場合他のお店へ行く',
  },
]);

// 打合せ履歴：無料提案件数（残）の表示ラベル
export const FreeProposalLevels = Object.freeze([
  { key: -1, value: '表示しない' }, // -1 は非表示
  { key: 2, value: '無料提案残②' }, // 残 2
  { key: 1, value: '無料提案残①' }, // 残 1
  { key: 0, value: '無料提案残⓪' }, // 残 0
  { key: 9, value: '以降無料提案' },
]);

// タスクの履歴タイプ
export const HISTORY_TYPE = Object.freeze({
  NEW_CARD: 0, // カード作成
  ADD_COMMENT: 1, // コメント追加
  CHECKED_ITEM: 2, // チェックリスト項目完了
  COMPLETED_CARD: 3, // カード完了
  EXPIRY_CHANGED: 4, // 期限変更
});
